
import axios from "axios";
import { reactive,ref } from "vue";
import { loading, errors, toast ,meta, loadingBtn, remove } from "./shared";

export default function useSaleRoute(navigation) {
  const { route, router } = navigation;
  const saleRoutes = ref([]);
const saleRoute = reactive({items: []});
  const getSaleRoutes = async (query = {}) => {
    try {
      errors.value = "";
      loading.value = true;
      const search = isObjectNotEmpty(query) ? "?" + new URLSearchParams(query).toString() : "";
      let response = await axios.get("user/sale-route" + search);
      loading.value = false;
      saleRoutes.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };


  const getSaleRoute = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/sale-route/" + route.params.id);
      loading.value = false;
      Object.assign(saleRoute,response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const editSaleRoute = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/sale-route/"+route.params.id+"/edit");
      loading.value = false;
      Object.assign(saleRoute,response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeSaleRoute = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.post("user/sale-route",saleRoute);
      progressDialog.value = false;
      toast.success(response.data.message);
      if(history.state.back) router.back();
      else router.push({name: 'user.sale_routes'});
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const updateSaleRoute = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.put("user/sale-route/" + saleRoute.id, saleRoute);
      const index = saleRoutes.value.findIndex((item) => item.id === saleRoute.id);
      saleRoutes.value[index] = response.data.data;
      progressDialog.value = false;
      toast.success(response.data.message);
      if(history.state.back) router.back();
      else router.push({name: 'user.sale_routes'});
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const moveSaleProcess = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      let response = await axios.put("user/sale-process/move", remove);
      toast.success(response.data.message);
      document.getElementById('move-modal').checked = false;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const removeSaleRoute = async () => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/sale-route/" + remove.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById("delete-modal").checked = false;
      if(remove.single){
        if(history.state.back) router.back();
        else router.push({name: 'user.sale_routes'});
      }else getSaleRoutes(route.query);
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const removeSaleProcess = async () => {
    try {
      loadingBtn.value = true;
      let response = await axios.post("user/sale-process/destroy",remove);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById("delete-modal").checked = false;
      saleRoute.items = saleRoute.items.filter(item => item.id != remove.process_id);
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };
  return {
    saleRoutes,
    saleRoute,
    getSaleRoutes,
    getSaleRoute,
    editSaleRoute,
    storeSaleRoute,
    updateSaleRoute,
    moveSaleProcess,
    removeSaleRoute,
    removeSaleProcess,
  };
}
